import script from "./UserSingle.vue?vue&type=script&setup=true&lang=js"
export * from "./UserSingle.vue?vue&type=script&setup=true&lang=js"

import "./UserSingle.vue?vue&type=style&index=0&id=232fce30&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-232fce30"]])

export default __exports__